<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        {{ this.$route.meta.title }}
                        <div class="clear"></div>
                    </div>
                    <event-write-component :eventType="'eventCreate'"></event-write-component>
                </div>
                <page-footer></page-footer>
            </div>
        </div>
    </div>
</template>

<script>
import EventWriteComponent from "@/components/event/EventWriteComponent";

export default {
    name: 'EventCreate',
    components: {
        EventWriteComponent
    },
    mixins: [],
    data() {
        return{

        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>
